export enum SentryEnvironment {
  Local = 'local',
  Dev = 'dev',
  Stage = 'stage',
  Prod = 'prod',
}
